import { NavLink, useNavigate } from "react-router-dom";
import { Bell, ChevronRight, ClipboardList, LayoutGrid, SlidersHorizontal, UsersRound } from "lucide-react";
import { clsx } from "clsx";
import { resolveAssetUrl } from "@/lib/api-client";
import { useAppStore } from "@/store/app-store";
import { initials } from "@/lib/format";

const moreTabs = [
  { to: "/more", label: "Overview", end: true },
  { to: "/guests", label: "Guests", end: false },
  { to: "/reports", label: "Reports", end: false },
];

const settingsItems = [
  { to: "/settings/general", icon: ClipboardList, label: "Property information", hint: "Address, contact, taxes" },
  { to: "/notifications", icon: Bell, label: "Notifications", hint: "Booking alerts and reminders" },
  { icon: UsersRound, label: "Team & permissions", hint: "Coming soon" },
  { icon: SlidersHorizontal, label: "App preferences", hint: "Coming soon" },
];

export function MorePage() {
  const navigate = useNavigate();
  const user = useAppStore((state) => state.user);
  const activeProperty = useAppStore((state) => state.activeProperty);
  const isAdmin = user?.role === "ADMIN";

  return (
    <main className="page more-page">
      <section className="resource-head">
        <span className="eyebrow"><LayoutGrid size={14} /> More</span>
      </section>

      <nav className="more-tabs">
        {moreTabs.map(({ to, label, end }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => clsx("more-tab", isActive && "active")}>
            {label}
          </NavLink>
        ))}
      </nav>

      <button type="button" className="more-profile-card" onClick={() => navigate("/profile")}>
        {user?.avatarUrl ? <img className="avatar" src={resolveAssetUrl(user.avatarUrl)} alt="" /> : <span className="avatar">{initials(user?.name)}</span>}
        <span className="more-profile-card__text">
          <strong>{user?.name}</strong>
          <small>{isAdmin ? "Administrator" : "Owner"}{activeProperty ? ` · ${activeProperty.name}` : ""}</small>
        </span>
        <ChevronRight size={18} />
      </button>

      {isAdmin && (
        <>
          <h2 className="more-section-title">Property settings</h2>
          <div className="more-settings-list">
            {settingsItems.map((item) =>
              item.to ? (
                <NavLink key={item.label} to={item.to} className="more-settings-item">
                  <span className="more-settings-item__icon"><item.icon size={18} /></span>
                  <span className="more-settings-item__text"><strong>{item.label}</strong><small>{item.hint}</small></span>
                  <ChevronRight size={18} />
                </NavLink>
              ) : (
                <div key={item.label} className="more-settings-item more-settings-item--disabled">
                  <span className="more-settings-item__icon"><item.icon size={18} /></span>
                  <span className="more-settings-item__text"><strong>{item.label}</strong><small>{item.hint}</small></span>
                </div>
              ),
            )}
          </div>
        </>
      )}
    </main>
  );
}
